import { api } from "../api";
import { renderDocumentsTab, attachDocumentsListeners } from "./student-documents";
import { hasPortalFeature } from "../utils/portal-features";

export async function render(el: HTMLElement) {
  // Ohne die Funktion "Eigene Dokumente hochladen" bleibt nur der Download-Bereich
  const canUpload = hasPortalFeature("dokumenteUpload");

  el.innerHTML = `
    <div style="max-width:900px;margin:0 auto;padding:1rem">
      <h1 style="font-size:1.5rem;font-weight:600;margin-bottom:.25rem">Meine Dokumente</h1>
      <p style="color:var(--gray-600);font-size:.9rem;margin-bottom:1.25rem">
        ${canUpload
          ? `Lade hier eigene Dokumente hoch (z.B. Atteste, Bescheinigungen) oder lade Dokumente herunter,
             die deine Schule für dich abgelegt hat.`
          : `Hier findest du die Dokumente, die deine Schule für dich abgelegt hat.`}
      </p>
      <div class="card" style="padding:1.25rem">
        <div id="my-docs-container">${renderDocumentsTab({ canUpload })}</div>
      </div>
    </div>
  `;

  const container = el.querySelector<HTMLElement>("#my-docs-container")!;
  attachDocumentsListeners({
    list: () => api.myDocuments.list(),
    upload: (file) => api.myDocuments.upload(file),
    download: (docId, name) => api.myDocuments.download(docId, name),
    delete: (docId) => api.myDocuments.delete(docId),
    rename: (docId, name) => api.myDocuments.rename(docId, name),
  }, container);
}
